import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrganizationAddressRequest } from "Api/organizations/address/getOrganizationAddress.request";
import logger from "Libs/logger";

import type { OrganizationAddress } from "Api/organizations/address/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const getOrganizationAddress = createAsyncThunk<
  OrganizationAddress,
  { organizationId: string },
  AsyncThunkOptionType
>(
  "app/organization/get_organization_address",
  async ({ organizationId }, { rejectWithValue }) => {
    try {
      const address = await getOrganizationAddressRequest(organizationId);

      return address;
    } catch (error: unknown) {
      logger(error, {
        action: "get_organization_address",
        organizationId
      });

      return rejectWithValue(error);
    }
  }
);
